import React from "react";

import TwoPanelDialog, { JustifyContent } from "components/TwoPanelDialog";

import Open from "./Open";
import Title from "./Title";
import Stepper from "./Stepper";
import Actions from "./Actions";
import Content from "./Content";

import { useAppDispatch, useAppSelector } from "store";
import { hideFilters, selectFiltersVisibility } from "modules/customer/insights/portfolio/filters/filtersSlice";

const Filters: React.FC = () => {
    const dispatch = useAppDispatch();
    const filtersVisibility = useAppSelector(selectFiltersVisibility);

    const handleClose = () => {
        dispatch(hideFilters());
    };

    return (
        <>
            <Open />
            <TwoPanelDialog
                open={filtersVisibility.isVisible}
                onClose={handleClose}
                leftPanelTitle={<Title />}
                leftPanelContent={<Stepper />}
                leftPanelActions={<Actions />}
                leftPanelActionsJustifyContent={JustifyContent.SpaceBetween}
                rightPanelContent={<Content />}
            />
        </>
    );
};

export default Filters;
